import * as Yup from "yup";
import checkout from "./form";

const {
  formField: {
    nameOfProductionBusinessActivities,
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId,
    projectName,
    addressActive,
    addressWard,
    addressDistrict,
    addressCity,
    contract,
    projectDay,
    projectOf,
    taxAgentName,
    taxAgentId,
    taxAgencyName,
    taxAgencyId,
    contractNumber,
    contractDay,
    fullName,
    signer,
    timeSign,
  },
} = checkout;

const validation = Yup.object().shape({
  [taxAgentName.name]: Yup.string().notRequired(taxAgentName.errorMsg),
  [nameOfProductionBusinessActivities.name]: Yup.string().required(
    nameOfProductionBusinessActivities.errorMsg
  ),
  [fullName.name]: Yup.string().required(fullName.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [signer.name]: Yup.string().required(signer.errorMsg),
  [supplementaryForThe.name]: Yup.string()
    .matches(/^\d+$/, supplementaryForThe.invalidMsg)
    .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
    .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [taxCalculationPeriod.name]: Yup.number().required(taxCalculationPeriod.errorMsg),
  [taxId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxId.invalidMsg)
    .required(taxId.errorMsg),
  [taxpayerName.name]: Yup.string().required(taxpayerName.errorMsg),
  [timeSign.name]: Yup.number().required(timeSign.errorMsg),
  [contractNumber.name]: Yup.number().required(contractNumber.errorMsg),
  [contractDay.name]: Yup.number().required(contractDay.errorMsg),
  [addressWard.name]: Yup.number().required(addressWard.errorMsg),
  [addressDistrict.name]: Yup.number().required(addressDistrict.errorMsg),
  [addressCity.name]: Yup.number().required(addressCity.errorMsg),

  [projectName.name]: Yup.string().required(projectName.errorMsg),
  [addressActive.name]: Yup.string().required(addressActive.errorMsg),
  [contract.name]: Yup.string().required(contract.errorMsg),
  [projectDay.name]: Yup.string().required(projectDay.errorMsg),
  [projectOf.name]: Yup.string().required(projectOf.errorMsg),
  [taxAgentId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, taxAgentId.invalidMsg)
    .required(taxAgentId.errorMsg),
});

export default validation;
